module.exports = __webpack_public_path__ + "img/blue_042.134c7cfa.png";